//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required
} from 'vuelidate/lib/validators';

export default {
  name: "Comments",

  data: function () {
    return {
      comments: [],

      formCreate: {
        name: "",
        message: "",
      },

      isFormCreate: false,
      isListComments: false,
    }
  },

  validations: function () {
    const formCreate = {
      name: {
        required,
      },
      message: {
        required
      },
    };

    return {
      formCreate,
    };
  },

  props: {
    model: {
      type: String,
      default: ""
    },
    modelKey: {
      type: [String, Number],
      default: ""
    }
  },

  computed: {
    isVisible: function () {
      return Boolean(this.$store.state?.user?.user?.id)
    },

    errorName: function () {
      const error = this.$v?.formCreate?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null;
      }

      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill');
      }

      return null;
    },
    errorMessage: function () {
      const error = this.$v?.formCreate?.message;
      if (!error?.$invalid || !error?.$dirty) {
        return null;
      }
      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill');
      }
      return null;
    },
  },

  mounted: async function () {
    await this.getComments();
  },

  methods: {
    getComments: async function () {
      const res = await this.$api.agent.transport.get(`/reviews?filter[model]=${this.model}&filter[model_key]=${this.modelKey}`).then((res) => {
        return res.data
      }).catch(() => {
        return []
      })
      this.comments = res;
    },
    changeIsListComments: function () {
      this.isListComments = !this.isListComments;
    },

    createComment: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit("loading/setLoading", true);

      const user = this.$store.state.user.user;
      const body = {
        "name": this.formCreate.name,
        "email": user?.email,
        "text": this.formCreate.message,
        "entities": [
          {
            "model": this.model,
            "model_key": this.modelKey
          }
        ]
      };
      const res = await this.$api.agent.transport.post('/reviews', body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      this.formCreate = {
        name: "",
        message: "",
      };
      this.isFormCreate = false;
      this.$v.$reset();
      this.$store.commit("loading/setLoading", false);
      this.$toast.success(this.$t('comments.send_comment_moderation'))
    },
    openFormCreate: function () {
      this.isFormCreate = true;
    },



    _parseDate: function (comment) {
      let date = comment.published_at * 1000;
      const locale = this.$i18n.locale;
      return new Date(date).toLocaleString(locale, {
        day: "numeric",
        month: "long",
        year: "numeric",
      }).split(',').join(' ');
    }
  }
}
